import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["submit", "checkbox"]
  static values = {
    initialCheckboxStates: Array
  }

  connect() {
    // Store initial checkbox states
    this.initialCheckboxStatesValue = this.checkboxTargets.map(checkbox => checkbox.checked)
    this.updateButtonState()
  }

  checkboxChanged() {
    this.updateButtonState()
  }

  updateButtonState() {
    const currentStates = this.checkboxTargets.map(checkbox => checkbox.checked)
    const hasChanges = this.initialCheckboxStatesValue.some((initialState, index) =>
      initialState !== currentStates[index]
    )

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = !hasChanges
    }
  }
}